import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function AddFacing() {
  const [facing, setFacing] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      facing: facing,
    };
    try {
      const res = await HomeService.addFacing(data); 
      if (res?.status) {
        toast.success("Facing added successfully!");
        clearAddForm();
        navigate("/manage-facing");
      }
    } catch (error) {
      toast.error("Failed to add Facing.");
      console.error("Error adding Facing:", error);
    }
  };

  const clearAddForm = () => {
    setFacing("");
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add Facing
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label htmlFor="facing">
                    Facing<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="facing"
                    className="form-control"
                    value={facing}
                    onChange={(e) => setFacing(e.target.value)}
                    placeholder="Enter Facing"
                    required
                  />
                </div>
              </div>
              <button type="submit" style={{
                                    background:'rgb(133, 218, 79)',
                                    borderRadius:'13px'
                                }} className="btn mt-3">
                Add Facing
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddFacing;
